/**
 * ТОКЕНЫ ДЛЯ JS / inline-стилей.
 *
 * Значения — ссылки на CSS-переменные из `css/tokens.css` (единый источник правды).
 * Так inline-стиль компонента и CSS-файл используют одно и то же значение,
 * а тему можно менять в одном месте (tokens.css), не трогая JS.
 *
 * Использование:
 *   import { color, space, radius } from "src/style";
 *   <div style={{ color: color.primary, padding: space[4], borderRadius: radius.md }} />
 */

export const color = {
  primary: "var(--ui-primary)",
  primaryHover: "var(--ui-primary-hover)",
  primaryActive: "var(--ui-primary-active)",
  primarySoft: "var(--ui-primary-soft)",
  primaryContrast: "var(--ui-primary-contrast)",

  success: "var(--ui-success)",
  successHover: "var(--ui-success-hover)",
  successSoft: "var(--ui-success-soft)",

  danger: "var(--ui-danger)",
  dangerHover: "var(--ui-danger-hover)",
  dangerSoft: "var(--ui-danger-soft)",

  warning: "var(--ui-warning)",
  warningHover: "var(--ui-warning-hover)",
  warningSoft: "var(--ui-warning-soft)",

  info: "var(--ui-info)",
  infoSoft: "var(--ui-info-soft)",

  ink: "var(--ui-ink)",
  text: "var(--ui-text)",
  textMuted: "var(--ui-text-muted)",
  textFaint: "var(--ui-text-faint)",
  textInverse: "var(--ui-text-inverse)",

  bg: "var(--ui-bg)",
  surface: "var(--ui-surface)",
  surfaceAlt: "var(--ui-surface-alt)",
  surfaceHover: "var(--ui-surface-hover)",

  border: "var(--ui-border)",
  borderStrong: "var(--ui-border-strong)",
  borderFocus: "var(--ui-border-focus)",
};

export const space = {
  0: "var(--ui-space-0)",
  1: "var(--ui-space-1)",
  2: "var(--ui-space-2)",
  3: "var(--ui-space-3)",
  4: "var(--ui-space-4)",
  5: "var(--ui-space-5)",
  6: "var(--ui-space-6)",
  8: "var(--ui-space-8)",
  10: "var(--ui-space-10)",
};

export const radius = {
  xs: "var(--ui-radius-xs)",
  sm: "var(--ui-radius-sm)",
  md: "var(--ui-radius-md)",
  lg: "var(--ui-radius-lg)",
  xl: "var(--ui-radius-xl)",
  pill: "var(--ui-radius-pill)",
};

export const font = {
  family: "var(--ui-font-family)",
  size: {
    xs: "var(--ui-font-size-xs)",
    sm: "var(--ui-font-size-sm)",
    md: "var(--ui-font-size-md)",
    lg: "var(--ui-font-size-lg)",
    xl: "var(--ui-font-size-xl)",
    "2xl": "var(--ui-font-size-2xl)",
  },
  weight: {
    regular: "var(--ui-font-weight-regular)",
    medium: "var(--ui-font-weight-medium)",
    bold: "var(--ui-font-weight-bold)",
  },
};

export const shadow = {
  sm: "var(--ui-shadow-sm)",
  md: "var(--ui-shadow-md)",
  lg: "var(--ui-shadow-lg)",
  focus: "var(--ui-shadow-focus)",
};

export const zIndex = {
  base: "var(--ui-z-base)",
  dropdown: "var(--ui-z-dropdown)",
  sticky: "var(--ui-z-sticky)",
  modalBackdrop: "var(--ui-z-modal-backdrop)",
  modal: "var(--ui-z-modal)",
  toast: "var(--ui-z-toast)",
};

export const transition = {
  fast: "var(--ui-transition-fast)",
  base: "var(--ui-transition-base)",
  slow: "var(--ui-transition-slow)",
};

/** Единый объект темы — удобно прокинуть целиком. */
export const theme = { color, space, radius, font, shadow, zIndex, transition };
